exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-footer-margin {\n  min-height: 5.2rem;\n  border-top: 0.15rem solid #34617b;\n  background-color: #4b8bb1 !important;\n  border-radius: 0 !important;\n  color: #ffffff;\n  z-index: 1003;\n}\n.page-footer-margin .continue-action {\n  padding-top: 1rem;\n}\n.page-footer-margin .footer-menu-padding {\n  justify-content: flex-end;\n}\n.page-footer-margin .link {\n  color: #ffffff !important;\n  cursor: pointer;\n}\n.page-footer-margin .disabled-link {\n  color: #c1c7d3 !important;\n  pointer-events: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/pageFooter.less
// module id = 3188
// module chunks = 0